<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
    <button class="btn btn-primary mb-1 edit-button" @click="itemAction('edit', rowData, rowIndex)"><i class="icons icon-note"></i>&nbsp;{{ 'Edit' | translate }}</button>
    <button class="btn btn-danger mb-1 delete-button"  v-if="(typeof this.rowField['disableFn'] !== 'undefined' && typeof this.rowField['disableFn'].delete !== 'undefined') !== true" @click="itemAction('delete', rowData, rowIndex)"><i class="icons icon-trash"></i>&nbsp;{{ 'Delete' | translate }}</button>
  </div>
  </td>
</template>

<script>
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  methods: {
    // Resolve the route prefix for action links. Defaults to the current route's
    // path (the historical behavior for top-level list views), but can be
    // overridden per-field via `basePath` so this component works inside nested
    // views like EditCustomer where $route.path is not a valid base.
    actionBasePath () {
      var rf = this.rowField || {}
      return rf.basePath || this.$route.path
    },
    itemAction (action, data, index) {
      if (action === 'delete' && !confirm(this.$t('Are you sure?'))) {
        return
      }
      this.$router.push({ path: this.actionBasePath() + '/' + action + '/' + data.id })
    }
  }
}
</script>


// WEBPACK FOOTER //
// VueTableActions.vue?94d2ac0c